import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import ApprovalRequestsList from "./ApprovalRequestsList";
import { Card } from "reactstrap";
import FinanceApprovalPageHeader from "../components/ApprovalPageHeader";
import {
  checkPermission,
  fetchAllPostPromisedData,
} from "../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint, regex } from "../../../common/constant";
import { successToast } from "../../../common/utils/methods/toasterFunctions/function";
import AMultiFieldSearchInput from "../../../../../../components/AMultiFieldSearchInput/AMultiFieldSearchInput";

import AButton from "../../../common/form-fields-mui/AButton";
import APopover from "../../../common/a-popover";
import FilterForm from "./FilterForm";
import { searchInputOptions } from "./utils";
import ShowOnlyPendingRequestsCheckbox from "./ShowOnlyPendingRequestsCheckbox";
import { ReactComponent as BackArrow } from "../../../../../../assets/img/svg/BackArrow.svg";
import { useHistory } from "react-router-dom";

const PaymodeApproval = ({ userPermissions }) => {
  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns
  );

  const [approvalRequestsInfo, setApprovalRequestsInfo] = useState({
    data: [],
    currentPage: 0,
    totalRecords: 0,
  });
  const [allActiveBu, setAllActiveBu] = useState([]);

  const history = useHistory();

  const isApproverPermission = checkPermission(userPermissions, "A");

  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [showOnlyPendingRequests, setShowOnlyPendingRequests] = useState(false);

  // const allActiveBu = useGetAllBusinessArea(true);

  const getApprovalRequests = async (
    page = 0,
    filters = {},
    activeBUs = allActiveBu
  ) => {
    try {
      setLoading(true);
      const updatedFilters = {
        ...filters,
        ...(!filters?.businessArea?.length && {
          businessArea: activeBUs?.map((bu) => bu?.value),
        }),
      };
      const resp = await fetchAllPostPromisedData(
        `${endpoint.paymodeApproval.search}?offset=${page}`,
        updatedFilters
      );
      if (resp?.code === 200) {
        const {
          paymentModeUpdateApprovalList: data,
          currentPage,
          totalRecords,
        } = resp?.data;
        setApprovalRequestsInfo({
          data,
          currentPage,
          totalRecords,
        });
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const updateStatus = async ({
    id,
    status,
    remark = "",
    acknowledgementId,
  }) => {
    try {
      setLoading(true);
      const reqObj = { status, remark, acknowledgementId };
      const resp = await fetchAllPostPromisedData(
        `${endpoint.paymodeApproval.updateStatus}/${id}`,
        reqObj,
        "put"
      );
      if (resp?.code === 200) {
        successToast("Request completed successfully!");
        await getApprovalRequests();
      }
    } catch (err) {
      console.error(err);
    }finally{
      setLoading(false);
    }
  };

  const pageChangeHandler = (newPage) => {
    applyFilterHandler(newPage);
  };

  const handleFilterForm = (value, key) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };

  const getFilterCount = () => {
    const {
      businessArea = [],
      status = "",
      receiptingDateFrom = "",
      receiptingDateTo = "",
    } = filterForm;

    const fields = [
      businessArea.length,
      status,
      receiptingDateFrom,
      receiptingDateTo,
    ];

    return fields.filter(Boolean).length;
  };

  const applyFilterHandler = (pageNumber = 0) => {
    const {
      businessArea = [],
      status = "",
      receiptingDateFrom = "",
      receiptingDateTo = "",
    } = filterForm;
    const filterObj = {
      businessArea: businessArea?.map((bu) => bu.value),
      status: status?.value ?? "",
      receiptingDateFrom,
      receiptingDateTo,
    };
    setFilterForm((prev) => ({
      ...prev,
      appliedFilterCount: getFilterCount(),
    }));
    setShowOnlyPendingRequests(false);

    getApprovalRequests(pageNumber, filterObj);
  };

  const removeFilterHandler = () => {
    getApprovalRequests();
    setFilterForm({});
  };

  const cancelSearchHandler = () => {
    getApprovalRequests(0);
  };

  const searchHandler = (key, value) => {
    const filters = { [key]: value };
    getApprovalRequests(0, filters);
    setFilterForm({});
  };

  const showOnlyPendingRequestsHandler = (checked) => {
    setShowOnlyPendingRequests(checked);
    if (checked) {
      getApprovalRequests(0, { status: "Pending" });
      setFilterForm({});
    } else getApprovalRequests();
  };

  const init = async () => {
    try {
      const buDropdown = masterDropdowns?.allBusinessAreaList.map(
        ({ label, businessAreaId, ...rest }) => ({
          ...rest,
          label,
          value: businessAreaId,
          businessAreaId,
        })
      );
      setAllActiveBu(buDropdown);
      getApprovalRequests(0, {}, buDropdown);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <FinanceApprovalPageHeader
        heading="Payment mode change approvals"
        subHeading="Here you can approve the change requests for payment modes"
      />

      <Card className="m-3 px-2 pt-3">
        <div className="d-flex justify-content-between">
          <div>
            <BackArrow
              className="mr-2 cursor"
              onClick={() => history.goBack()}
            />
            <h3 className="d-inline">Manage Receipts</h3>
          </div>

          <div
            className="d-flex justify-content-between"
            style={{ columnGap: "10px" }}
          >
            <ShowOnlyPendingRequestsCheckbox
              checked={showOnlyPendingRequests}
              showOnlyPendingRequestsHandler={showOnlyPendingRequestsHandler}
            />
            <AMultiFieldSearchInput
              options={searchInputOptions}
              searchHandler={searchHandler}
              crossHandler={cancelSearchHandler}
            />

            <APopover
              buttonComponent={(openPopover) => (
                <AButton
                  variant="outline"
                  onClick={openPopover}
                  size="xs"
                  className="no-ml-btn"
                >
                  Filter
                  {filterForm?.appliedFilterCount > 0
                    ? `(${filterForm?.appliedFilterCount})`
                    : ""}
                </AButton>
              )}
              menuComponent={(closePopup) => (
                <FilterForm
                  businessAreaDropdown={allActiveBu}
                  form={filterForm}
                  applyFilterHandler={applyFilterHandler}
                  handleFilterForm={handleFilterForm}
                  closePopup={closePopup}
                  removeFilterHandler={removeFilterHandler}
                  filterCount={getFilterCount()}
                />
              )}
            />
          </div>
        </div>
        <hr className="my-2" />
        <ApprovalRequestsList
          approvalRequestsInfo={approvalRequestsInfo}
          updateStatus={updateStatus}
          allActiveBu={allActiveBu}
          pageChangeHandler={pageChangeHandler}
          loading={loading}
          isApprovePermission={isApproverPermission}
        />
      </Card>
    </>
  );
};

export default PaymodeApproval;
